import { render, staticRenderFns } from "./dealerCountDetail.vue?vue&type=template&id=039f83a2&scoped=true&"
import script from "./dealerCountDetail.vue?vue&type=script&lang=js&"
export * from "./dealerCountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f83a2",
  null
  
)

export default component.exports